<template>
  <v-card v-if="items.length > 0">
    <v-card-title class="py-0">
      <h4>{{ title }}</h4>
      <v-spacer />
      <v-btn 
        icon 
        small 
        @click.native="addMultiple()"
      >
        <v-icon 
          dark 
          :color="isMultiple ? 'pink' : 'grey darken-2'"
        >
          playlist_add_check
        </v-icon>
      </v-btn>
      <v-btn 
        icon
        small
        @click.native="clearFilter()"
      >
        <v-icon 
          dark 
          :color="isClear ? 'pink' : 'grey darken-2'"
        >
          clear
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-card-title class="py-1">
      <template v-for="(item, index) in categories">
        <v-btn
          :key="index"
          round
          small
          :outline="!item.value"
          class="ma-1"
          :color="item.value ? 'grey lighten-2' : ''"
          @click.native="item.value = !item.value; filterSet(item)"
        >
          {{ item.label }}
        </v-btn>
      </template>
    </v-card-title>
    <v-card-text class="pt-0">
      <div v-if="growth.series !== undefined && growth.series.length > 0">
        <vue-highcharts
          :options="growth"
          style="width: 100%; height: 250px"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import VueHighcharts from "@/components/vueHighcharts.vue";
import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
highchartsMore(Highcharts);
import _ from "lodash";

export default {
  components: {
    VueHighcharts
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    categories: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    chartType: {
      type: String,
      default: "column"
    },
    tooltipSplit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMultiple: false,
      isClear: false
    }
  },
  computed: {
    growth: function() {
      var option = {
        chart: {
          backgroundColor: null,
          type: this.chartType,
          style: {
            fontFamily: "Roboto"
          }
        },
        title: {
          text: ""
        },
        xAxis: {
          type: "category"
        },
        yAxis: {
          title: {
            text: ""
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          shadow: false
        },
        tooltip: {
          headerFormat: "",
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> ({point.percentage:.1f}%)<br/>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %"
            }
          }
        },
        series: []
      };

      if (this.items.length > 0) {
        let datas = [];
        this.items.forEach(function(item) {
          let obj = {};
          obj.name = item.label;
          obj.y = item.count;

          datas.push(obj);
        });

        option.series.push({
          data: datas
        });
      }

      return option;
    }
  },
  methods: {
    filterSet(item) {
      let falseCount = 0
      for (var i = 0; i < this.categories.length; i++) {
        if (!this.categories[i].value) {
          falseCount++
        }
        if (!this.isMultiple) {
          if (item.label !== this.categories[i].label) {
            this.categories[i].value = true
          } else {
            this.categories[i].value = false
          }
        }
      }
      
      if (falseCount == this.categories.length) {
        for (var i = 0; i < this.categories.length; i++) {
          this.categories[i].value = true
        }      
        this.isClear = false
      } else {
        this.isClear = true
      }
      this.$emit('fetchData');
    },
    addMultiple() {
      this.isMultiple = !this.isMultiple
    },
    clearFilter() {
      this.isClear = false
      for (var i = 0; i < this.categories.length; i++) {
        this.categories[i].value = true;
      }

      this.$emit("fetchData");
    }
  }
};
</script>

<style scoped>
.v-chip {
  min-width: 60px;
}
.v-chip:hover {
  cursor: pointer;
}
.v-btn--floating.v-btn--small {
  width: 28px;
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/views/removal_chart.vue